module.exports = __webpack_public_path__ + "static/media/tutorial-goal-background.0a44edf3.svg";